import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EditorSpecialFieldsOptions } from "@dev/template-editor";
import { getCustomFieldsStore } from "@/store/customFields/actions";
import { SpecialField, SpecialFieldGroup } from "./types";
import { useStaticEmailSpecialFields } from "./hooks/useStaticEmailSpecialFields";
import { getSpecialFieldWithFreeValueRegex } from "./tools/getSpecialFieldWithFreeValueRegex";

interface SpecialFields {
    editorOptions: EditorSpecialFieldsOptions,
    list: SpecialField[],
}

interface EmailTemplateSpecialFieldsProps {
    disableGeneralGroup?: boolean; // true in buttons,
    disableCheckoutGroup?: boolean;
    disableByName?: string[]
}

export const useEmailTemplateSpecialFields = ({
    disableGeneralGroup = false,
    disableCheckoutGroup = true,
    disableByName
}: EmailTemplateSpecialFieldsProps): SpecialFields => {
    const { t } = useTranslation();
    const customFields = useSelector(getCustomFieldsStore);
    const staticSpecialFields = useStaticEmailSpecialFields();
    const customSpecialFields = customFields?.collection?.map(({ Name }) => getSpecialFieldWithFreeValueRegex({
        id: `custom-${Name}`,
        group: SpecialFieldGroup.CONTACT,
        name: Name,
        regexKeyword: Name,
    })) ?? [];

    const filteredSpecialFields = disableGeneralGroup || disableCheckoutGroup || disableByName?.length ? 
        staticSpecialFields?.filter((specialField) => 
            !disableByName?.includes(specialField.name) &&
            !(disableGeneralGroup && specialField.group === SpecialFieldGroup.GENERAL) &&
            !(disableCheckoutGroup && specialField.group === SpecialFieldGroup.CHECKOUT)
    ) : staticSpecialFields;
    const list: SpecialField[] = [
        ...filteredSpecialFields,
        ...customSpecialFields
    ];

    return {
        list,
        editorOptions: {
            title: t('mergefields'),
            startChars: '{',
            endChars: '}',
            fields: list.filter(({isUIOnly}) => !isUIOnly)
        }
    };
}
